const content = `
# Simulation

The simulation section lets you configure equipment sizes, choose a load profile, and run a minute-by-minute energy flow simulation through your selected topology.

## Equipment Configuration

Configure five parameters that define your site equipment:

| Parameter | Field | Typical Range | Description |
|-----------|-------|--------------|-------------|
| Solar PV | \`pv_kw\` | 50 - 500 kW | Rated PV array capacity |
| BESS Power | \`bess_kw\` | 25 - 250 kW | Battery charge/discharge rate |
| BESS Capacity | \`bess_kwh\` | 100 - 1000 kWh | Battery energy storage capacity |
| Charger Count | \`charger_count\` | 2 - 20 | Number of EV chargers |
| Charger Power | \`charger_kw\` | 7 - 350 kW | Rated power per charger |

The simulation generates solar, EV, and AC load profiles based on these values and the selected load profile type.

## Load Profile Types

| Profile | Pattern | Typical Site |
|---------|---------|-------------|
| **Commercial** | 9 AM - 5 PM peak, low overnight | Office buildings, retail parks |
| **Fleet Depot** | Overnight charging, low daytime | Delivery fleets, transit depots |
| **Retail** | Daytime + evening peaks | Shopping centers, restaurants |
| **Residential** | Morning + evening twin peaks | Multifamily, condo complexes |

Each profile shapes the EV charging demand curve throughout the day. The solar profile follows a Gaussian bell curve peaking at solar noon regardless of load type.

## Duration

Choose between two simulation lengths:

- **24 Hours** (1,440 minutes) — Standard single-day simulation. Good for quick topology comparisons.
- **7 Days** (10,080 minutes) — Extended simulation showing weekly patterns including weekend variation.

## Running a Simulation

1. Confirm your selected topology is shown in the summary card at the top.
2. Adjust equipment sizes and load profile as needed.
3. Click **Run Simulation** (or **Compare Topologies** in compare mode).
4. Watch the animated progress indicator as the solver runs.
5. Results appear automatically when the simulation completes, and the view navigates to the Results section.

## What Happens Behind the Scenes

The frontend generates synthetic solar, EV, and AC load profiles from the equipment config, then sends them along with the topology ID to the PhD API. The API runs a physics-based simulation that traces power through every component in the topology (inverters, DC-DC converters, transformers, cables) using manufacturer efficiency curves, and returns minute-by-minute power flows.
`;

export default content;
